var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {}, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "custom-collapse",
              {
                staticClass: "mx-md-3",
                attrs: { id: "additional-question-collapse" }
              },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      disabled: !_vm.isDragAndDropEnable,
                      "force-fallback": "",
                      "ghost-class": "ghost",
                      list: _vm.input
                    },
                    on: {
                      end: function($event) {
                        _vm.dragging = false
                      },
                      start: function($event) {
                        _vm.dragging = true
                      }
                    }
                  },
                  _vm._l(_vm.input, function(item, key) {
                    return _c(
                      "custom-collapse-item",
                      {
                        key: `additional-question-collapse-item-${key + 1}`,
                        ref: `additional-question-collapse-item-${key + 1}`,
                        refInFor: true,
                        staticClass: "collapse-item mt-3",
                        class: { "border border-danger rounded": !item.valid },
                        attrs: {
                          id: `additional-question-collapse-item-${key + 1}`,
                          "auto-expand-collapse-enabled": false,
                          "button-icon": "far fa-times-circle color-red",
                          disabled: _vm.isReadOnly || _vm.isDragAndDropEnable,
                          expanded: item.expanded,
                          "expanded-icon": "fas fa-plus-circle color-gray-2",
                          "icon-class-when-button-disabled":
                            "fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center",
                          "keep-btn-visible": false,
                          "parent-id": "additional-question-collapse",
                          "show-icon-when-button-disabled":
                            _vm.isDragAndDropEnable,
                          title: _vm.title(item, key)
                        },
                        on: {
                          actionButtonClick: function($event) {
                            return _vm.quit(item, key)
                          },
                          expandButtonClick: function($event) {
                            return _vm.expand(item, key)
                          }
                        }
                      },
                      [
                        _c(
                          "validation-observer",
                          { ref: `additional-question-${key}`, refInFor: true },
                          [
                            !_vm.isLocality
                              ? _c(
                                  "div",
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c("validation-provider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function({ errors }) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            " Pregunta o Descripción: "
                                                          )
                                                        ]
                                                      ),
                                                      _c("custom-input", {
                                                        attrs: {
                                                          "custom-error-msg":
                                                            "El campor es requerido.",
                                                          error: errors[0],
                                                          maxlength: "500",
                                                          placeholder:
                                                            "Escribe tu Pregunta o Descripción"
                                                        },
                                                        model: {
                                                          value: item.name,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.name"
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _c("div", { staticClass: "row mt-3" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-md-5" },
                                        [
                                          _c("validation-provider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function({ errors }) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            " Opción de Respuesta: "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                item.typeId,
                                                              expression:
                                                                "item.typeId"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            error:
                                                              errors.length > 0
                                                          },
                                                          attrs: {
                                                            "custom-error-msg":
                                                              "El campo es requerido.",
                                                            error: errors[0],
                                                            placeholder:
                                                              "Seleccione"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  item,
                                                                  "typeId",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.onAnswerTypeChange(
                                                                  item
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                hidden: "",
                                                                selected: "",
                                                                value: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Seleccione "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.answersTypes,
                                                            function(
                                                              type,
                                                              keyType
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: keyType,
                                                                  staticClass:
                                                                    "fa",
                                                                  domProps: {
                                                                    value:
                                                                      type.id,
                                                                    innerHTML: _vm._s(
                                                                      `${type.icon} ${type.name}`
                                                                    )
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      ),
                                                      errors.length > 0
                                                        ? _c("custom-error", {
                                                            attrs: {
                                                              message:
                                                                "El campo es requerido",
                                                              variant:
                                                                "no-border mt-1"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    item.typeId == _vm.selection.simpleVertical
                                      ? _c("vertical-inputs", {
                                          attrs: { input: item.answers },
                                          on: {
                                            "update:input": function($event) {
                                              return _vm.$set(
                                                item,
                                                "answers",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.typeId == _vm.selection.simpleWithChild
                                      ? _c("simple-with-child", {
                                          attrs: {
                                            "answers-types": _vm.answersTypes,
                                            "child-questions":
                                              item.childQuestions,
                                            input: item.answers,
                                            "parent-index": key
                                          },
                                          on: {
                                            "update:childQuestions": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                item,
                                                "childQuestions",
                                                $event
                                              )
                                            },
                                            "update:child-questions": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                item,
                                                "childQuestions",
                                                $event
                                              )
                                            },
                                            "update:input": function($event) {
                                              return _vm.$set(
                                                item,
                                                "answers",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.typeId ==
                                    _vm.selection.multipleHorizontal
                                      ? _c("multiple-selection", {
                                          attrs: {
                                            input: item.answers,
                                            orientation: "horizontal"
                                          },
                                          on: {
                                            "update:input": function($event) {
                                              return _vm.$set(
                                                item,
                                                "answers",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.typeId ==
                                    _vm.selection.multipleVertical
                                      ? _c("multiple-selection", {
                                          attrs: {
                                            input: item.answers,
                                            orientation: "vertical"
                                          },
                                          on: {
                                            "update:input": function($event) {
                                              return _vm.$set(
                                                item,
                                                "answers",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.typeId == _vm.selection.numericalText
                                      ? _c("div", { staticClass: "row mt-3" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-md-5" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "text" },
                                                [_vm._v(" Texto Numérico: ")]
                                              ),
                                              _c("input", {
                                                staticClass:
                                                  "form-control custom-bg-disabled",
                                                attrs: {
                                                  disabled: "",
                                                  min: 0,
                                                  placeholder: "0",
                                                  type: "number"
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    item.typeId == _vm.selection.openText
                                      ? _c("div", { staticClass: "row mt-3" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-md-5" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "text" },
                                                [_vm._v(" Texto Abierto: ")]
                                              ),
                                              _c("custom-text-area", {
                                                attrs: {
                                                  disabled: "",
                                                  maxlength: 0,
                                                  placeholder:
                                                    "Escriba un comentario"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e(),
                                    item.typeId ==
                                    _vm.selection.simpleHorizontal
                                      ? _c("horizontal-inputs", {
                                          attrs: { input: item.answers },
                                          on: {
                                            "update:input": function($event) {
                                              return _vm.$set(
                                                item,
                                                "answers",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.typeId == _vm.selection.document
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 my-5 p-3 document-bg rounded-lg",
                                            staticStyle: {
                                              "background-color": "#F1F6F4"
                                            }
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "data-label" },
                                              [_vm._v(" Archivo ")]
                                            ),
                                            _c("action-button", {
                                              staticClass: "w-100 disabled",
                                              attrs: {
                                                disabled: true,
                                                i: "fas fa-file-plus",
                                                text:
                                                  "Presione aquí para anejar documento",
                                                variant:
                                                  "outline-grey mr-3 pl-3 pr-4"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("locality-form", {
                                      attrs: { "is-read-only": true },
                                      model: {
                                        value: item.location,
                                        callback: function($$v) {
                                          _vm.$set(item, "location", $$v)
                                        },
                                        expression: "item.location"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      !_vm.isReadOnly && !_vm.isLocality
        ? _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md flex-grow-1 d-flex align-items-center justify-content-end pr-md-4 pt-3"
              },
              [
                _c("action-button", {
                  staticClass: "px-3",
                  attrs: {
                    i: "fas fa-file-plus",
                    text: "Añadir",
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.add()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }